<template>
  <div>
    <form class="formStyle">
        <!-- <h2>Dodaj nową wytyczną</h2> -->
        <div>
            Akronim
            <input type="text" v-model="formData.name_short" class='shortText'>
        </div>
        <div>
            Pełna nazwa
            <input type="text" v-model="formData.name_jurnal" class='shortText'>
        </div>
        <div>
            Adres URL
            <input type="text" v-model="formData.url_guide" class='shortText'>
        </div>
        <div style="text-align: center;">
            <button type='button' @click="send()" class='buttonRDTL'>Dodaj wytyczną</button>
            <button type='button' @click="$router.push('/')" class='buttonRDTL' style='margin-left:10px'>Anuluj</button>
        </div>
    </form>

    <modal name="wrongData" styles="padding: 40px;text-align:center;" :width="500" :height="150">
        Wszystkie pola są wymagane<br><br>
        <button type='button' @click="$modal.hide('wrongData')" class='buttonRDTL' style='margin-left:10px'>OK</button>
    </modal>

  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import router from "../router.js"

  export default {
    data(){
        return{
            formData:{
                name_short: '',
                name_jurnal: '',
                url_guide: ''
            }
        }
    },
    methods: {
        ...mapActions("guide", ['addGuide']),
        send(){
            let self = this
            Object.keys(this.formData).forEach(function(key) {
                self.formData[key] = self.formData[key].trim()
            });
            if(this.formData.name_short=='' || this.formData.name_jurnal=='' || this.formData.url_guide==''){
                this.$modal.show('wrongData')
            }else{
                this.addGuide(this.formData).then((response)=>{
                    this.$router.push('/'); 
                }) 
            }
        },
    },
    created(){
    },
}

</script>

<style>

</style>